/** Default fill opacity slider (0–1) for overlays that have a visible fill. */
export const DEFAULT_REVIEW_FILL_OPACITY = 0.2;

/** When true, stroke/fill use per-annotator palette colors; when false, adapter colors are kept. */
export const DEFAULT_COLORIZE_BY_ANNOTATOR = true;

/** Matplotlib tab10-like palette for stable per-user hues in admin review. */
export const REVIEW_USER_COLOR_PALETTE = [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#7f7f7f',
    '#bcbd22',
    '#17becf',
];
